<template>
    <div class="mt-10">
        <div class="space-y-1 mt-6">
            <h3 class="px-3 text-xs pb-1 font-medium text-gray-500 tracking-wide">OTHER</h3>
            <div class="space-y-1" role="group" aria-labelledby="projects-headline">
                <a
                    v-for="item in secondaryNavigation" :key="item.name" :href="item.href"
                    class="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-200 hover:text-gray-900">
                    <span class="truncate">{{ item.name }}</span>
                </a>
            </div>
        </div>
    </div>

    <div v-if="accountNavigation.length !== 0" class="mt-10">
        <div class="space-y-1 mt-6">
            <h3 class="px-3 text-xs pb-1 font-medium text-gray-500 tracking-wide">ACCOUNT</h3>
            <div class="space-y-1" role="group" aria-labelledby="projects-headline">
                <Link
                    v-for="item in accountNavigation" :key="item.name" :method="item.method" :href="item.href"
                    :class="[item.current ? 'bg-gray-100' : '', item.hidden ? 'hidden' : '']"
                    class="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-200 hover:text-gray-900">
                    <span class="truncate">{{ item.name }}</span>
                </Link>
            </div>
        </div>
    </div>

</template>
<script>
import {Link} from '@inertiajs/vue3';

export default {
    components: {
        Link
    },
    props: {
        secondaryNavigation: {
            required: true,
            type: Object,
        },
        accountNavigation: {
            required: true,
            type: Object,
        }
    }
};
</script>
